var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRemoveTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "grid"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,11.5c-0.276,0-0.5,0.224-0.5,0.5c0,6.065-4.935,11-11,11S1,18.065,1,12S5.935,1,12,1   c2.771,0,5.386,1.018,7.417,2.876L12,11.293L8.854,8.146c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707L11.293,12   l-3.146,3.147c-0.195,0.195-0.195,0.512,0,0.707s0.512,0.195,0.707,0L12,12.707l3.146,3.146C15.244,15.951,15.372,16,15.5,16   s0.256-0.049,0.354-0.146c0.195-0.195,0.195-0.512,0-0.707L12.707,12l7.778-7.778c0.195-0.195,0.195-0.512,0-0.707   C18.219,1.248,15.206,0,12,0C5.383,0,0,5.383,0,12s5.383,12,12,12s12-5.383,12-12C24,11.724,23.776,11.5,23.5,11.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemoveTimer);
export default __webpack_public_path__ + "static/media/iconRemoveTimer.3f8f7c62296949dc7243574aef2d42a6.svg";
export { ForwardRef as ReactComponent };